import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["okProps", "onOk", "okText", "cancelText", "onCancel", "cancelProps", "content", "footer", "footerClassName", "footerStyle", "closable", "maskClosable"],
    _excluded2 = ["getContainer", "onCancel", "onOk"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file alert.tsx
 * @author markJia(markjia@tencent.com)
 */
import React from 'react';
import Render from 'react-dom';
import { DEFAULT_CONFIG_OPTIONS, Provider } from '../../context/config';
import { Modal } from './Modal';
import { Button } from '../Button';
var defaultFooterStyle = {
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'flex-end'
};
export var createFnModal = function createFnModal(type) {
  return function (props) {
    var okProps = props.okProps,
        onOk = props.onOk,
        _props$okText = props.okText,
        okText = _props$okText === void 0 ? '确认' : _props$okText,
        _props$cancelText = props.cancelText,
        cancelText = _props$cancelText === void 0 ? '取消' : _props$cancelText,
        onCancel = props.onCancel,
        cancelProps = props.cancelProps,
        content = props.content,
        footer = props.footer,
        footerClassName = props.footerClassName,
        footerStyle = props.footerStyle,
        _props$closable = props.closable,
        closable = _props$closable === void 0 ? false : _props$closable,
        _props$maskClosable = props.maskClosable,
        maskClosable = _props$maskClosable === void 0 ? false : _props$maskClosable,
        extra = _objectWithoutProperties(props, _excluded);

    var getFooterContent = function getFooterContent() {
      var cancelContent = type === 'confirm' && React.createElement(Button, _objectSpread(_objectSpread({}, cancelProps), {}, {
        onClick: onCancel,
        style: {
          marginRight: 16
        }
      }), cancelText);
      return React.createElement("div", {
        className: footerClassName,
        style: _objectSpread(_objectSpread({}, defaultFooterStyle), footerStyle)
      }, cancelContent, React.createElement(Button, _objectSpread(_objectSpread({
        type: "primary"
      }, okProps), {}, {
        onClick: onOk
      }), okText));
    };

    return React.createElement(Modal, _objectSpread(_objectSpread({}, extra), {}, {
      closable: closable,
      maskClosable: maskClosable,
      defaultShow: true,
      onCancel: onCancel,
      footer: footer || getFooterContent()
    }), content);
  };
};
export var withModalFn = function withModalFn(opt) {
  var type = opt.type,
      prefix = opt.prefix;
  var Component = createFnModal(type);
  return function (props) {
    var getContainer = props.getContainer,
        onCancel = props.onCancel,
        onOk = props.onOk,
        extra = _objectWithoutProperties(props, _excluded2);

    var parent = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
    var container = document.createElement('div');
    parent.appendChild(container);

    var destroy = function destroy() {
      Render.unmountComponentAtNode(container);
      parent.removeChild(container);
    };

    var cancelHandle = function cancelHandle() {
      onCancel === null || onCancel === void 0 ? void 0 : onCancel();
      destroy();
    };

    var okHandle = function okHandle() {
      Promise.resolve(onOk === null || onOk === void 0 ? void 0 : onOk()).then(function () {
        destroy();
      });
    };

    var render = function render(ops) {
      Render.render(React.createElement(Provider, {
        value: {
          prefix: prefix || DEFAULT_CONFIG_OPTIONS.prefix
        }
      }, React.createElement(Component, _objectSpread(_objectSpread({}, ops), {}, {
        onCancel: cancelHandle,
        onOk: okHandle
      }))), container);
    };

    render(extra);
    return {
      update: function update(config) {
        render(_objectSpread(_objectSpread({}, extra), config));
      }
    };
  };
};